module.exports = __webpack_public_path__ + "static/media/mkr.4e316b1b.svg";